import { render, staticRenderFns } from "./CandidateSearch.vue?vue&type=template&id=5bee118a&scoped=true&"
import script from "./CandidateSearch.vue?vue&type=script&lang=js&"
export * from "./CandidateSearch.vue?vue&type=script&lang=js&"
import style0 from "./CandidateSearch.vue?vue&type=style&index=0&id=5bee118a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bee118a",
  null
  
)

export default component.exports